module.exports = __webpack_public_path__ + "img/0Q3B1621-26_H_L_Black_MockedUp.5e678d4e.jpg";